import { render } from "./SamplePage.vue?vue&type=template&id=3cd7246f&scoped=true"
import script from "./SamplePage.vue?vue&type=script&lang=js"
export * from "./SamplePage.vue?vue&type=script&lang=js"

import "./SamplePage.vue?vue&type=style&index=0&id=3cd7246f&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd7246f"]])

export default __exports__